import { Money, ProductConditionCode } from "../../common/models/CommonModels";
import { ProductAvailabilityCode } from "../../customer/inventory/models/models";
import { FileModel, Page, Quantity, QueryBase } from "../../shared/models/models";

export interface AdminInventoryState {
  query: AdminStockItemsQuery,
  stockItems?: Page<AdminStockItem>;
  stockItem?: AdminStockItem,
  manufacturers: ManufacturerReference[],
  categories: CategoryReference[],
  loading: boolean,
  success?: string,
  error: any
}

export interface AdminChangeStockItemModel {
  groupId: string;
  categoryId: string;
  subcategoryId?: string;
  manufacturerId: string;
  manufacturerName: string;
  number: string;
  alternativeNumber?: string;
  conditionCode: ProductConditionCode;
  availabilityCode: ProductAvailabilityCode;
  quantity: Quantity;
  price?: Money;
  height?: number;
  width?: number;
  depth?: number;
  weight?: number;
  description?: string;
  file?: FileModel;
}

export interface ManufacturerReference {
  id: string;
  name: string;
}

export interface CategoryReference {
  id: string;
  name: string;
}

export interface AdminProductReference {
  number: string;
  manufacturer: ManufacturerReference;
  category: CategoryReference;
}

export interface AdminSupplierReference {
  id: string;
  name: string;
}

export interface AdminStockItem {
  id: string;
  alternativeNumber?: string;
  conditionCode: ProductConditionCode;
  availabilityCode: ProductAvailabilityCode;
  quantity?: Quantity;
  price?: Money;
  width?: number;
  height?: number;
  depth?: number;
  weight?: number;
  description?: string;
  product: AdminProductReference;
  supplier: AdminSupplierReference;
  file: FileModel | null;
}

export interface AdminStockItemsQuery extends QueryBase<AdminStockItemsQueryParameter> {
  manufacturerId?: string;
  categoryId?: string;
  availabilityId?: string;
  conditionCodes?: ProductConditionCode[];
}

export enum AdminStockItemsQueryParameter {
  Name = 1,
  Number = 2,
  ManufacturerName = 3,
  Condition = 4,
  Availability = 5,
  Price = 6,
  Quantity = 7,
  Weight = 8,
  SupplierName = 9
}
